import { FetchContractorNotes } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { NoteState } from './types'

const getInitialState = (): NoteState => ({
  notes: [],
})

export const notesReducer = (
  state: NoteState = getInitialState(),
  action: Action<any>,
): NoteState => {
  switch (action.type) {
    case FetchContractorNotes.type.SUCCESS:
      return {
        ...state,
        notes: action.payload,
      }
    default:
      return state
  }
}
